
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-stone-100 py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center">
              <img 
                src="https://static.readdy.ai/image/29014cc4b7daa6d5c6988d1d2c1b8cc2/9369c4398e685bc93ca98dee52c77f48.png"
                alt="Kent Zimmerman"
                className="w-full h-full object-contain"
              />
            </div>
            <span className="text-lg font-light text-gray-900">Kent Zimmerman</span>
          </div>
          <div className="flex gap-6">
            <a href="https://www.facebook.com/people/Kent-Zimmerman-Author-Artist/61584956443998/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center text-gray-600 hover:text-amber-700 transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-xl"></i>
            </a>
            <a href="https://www.threads.com/@theartofkent?xmt=AQF0XocT62Ll8Tku3CgQk8lpdO-Bj47sscvDVhMkCA8qDPg" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center text-gray-600 hover:text-amber-700 transition-colors cursor-pointer">
              <i className="ri-at-line text-xl"></i>
            </a>
            <a href="https://www.instagram.com/theartofkent/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center text-gray-600 hover:text-amber-700 transition-colors cursor-pointer">
              <i className="ri-instagram-fill text-xl"></i>
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center text-gray-600 hover:text-amber-700 transition-colors cursor-pointer">
              <i className="ri-linkedin-fill text-xl"></i>
            </a>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-300 text-center">
          <p className="text-sm text-gray-600">
            © 2025 Kent Zimmerman. All rights reserved. | <a href="https://www.leavittpeakpress.com" target="_blank" rel="noopener noreferrer" className="text-amber-700 hover:text-amber-800 cursor-pointer">Powered by Leavitt Peak Press</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
